import { FC } from "react";
import { useEffectOnceWhen } from "rooks";
import { useFlag } from "@unleash/proxy-client-react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../../../../../store/hooks";
import { useGetUsersMeOrganisationsCurrentBudgetsQuery } from "../../../../../../../../../../../services/cloudchipr.api";
import { isCurrentBudgetEditingSelector } from "../../../../../../../../../../../store/budgets/selectors/current-budget/data-selectors/isCurrentBudgetEditingSelector";
import { budgetFirstAvailableViewIdSelector } from "../../../../../../../../../../../store/budgets/selectors/current-budget/view/budgetFirstAvailableViewIdSelector";
import { HierarchyViewSelectionWrapper } from "../../../../../../../../../common/hierarchy-view-selection/HierarchyViewSelectionWrapper";
import { BudgetsAndAlertsHierarchySelectTrigger } from "../../../../common/BudgetsAndAlertsHierarchySelectTrigger";
import { currentBudgetViewIdSelector } from "../../../../../../../../../../../store/budgets/selectors/current-budget/data-selectors/currentBudgetViewIdSelector";
import { formDataSelector } from "../../../../../../../../../../../store/budgets/selectors/current-budget/forms/formDataSelector";
import { getResourceExplorerDataByBudgetThunk } from "@/store/budgets/thunks/getResourceExplorerDataByBudgetThunk";

interface BudgetViewSelectionWrapperProps {
  onChange(id: string): void;
  selectedItemId?: string;
}

export const BudgetViewSelectionWrapper: FC<
  BudgetViewSelectionWrapperProps
> = ({ onChange, selectedItemId }) => {
  const viewId = useAppSelector(currentBudgetViewIdSelector);

  const firstAvailableViewId = useAppSelector(
    budgetFirstAvailableViewIdSelector,
  );
  const enableCreateBudgetsBasedOnFilters = useFlag(
    "EnableCreateBudgetsBasedOnFilters",
  );

  const isEdit = useAppSelector(isCurrentBudgetEditingSelector);
  const formInitialData = useAppSelector(formDataSelector);

  const dispatch = useAppDispatch();
  const { data: budgets } = useGetUsersMeOrganisationsCurrentBudgetsQuery();

  useEffectOnceWhen(
    () => {
      if (isEdit && !enableCreateBudgetsBasedOnFilters) {
        dispatch(getResourceExplorerDataByBudgetThunk());
      } else if (!isEdit && viewId && !formInitialData?.viewId) {
        onChange(viewId);
      } else if (!formInitialData?.viewId) {
        firstAvailableViewId && onChange(firstAvailableViewId);
      }
    },
    isEdit || !!viewId || !!(budgets && firstAvailableViewId),
  );

  return (
    <HierarchyViewSelectionWrapper
      selectedItemId={selectedItemId ?? ""}
      onChange={onChange}
      CustomTriggerComponent={BudgetsAndAlertsHierarchySelectTrigger}
      visibility="visible_to_everyone"
    />
  );
};
